export default {
    courseData: {},
    courseSections: {}
};